import SuccessIcon from '/public/icons/check-circle.svg';

interface SuccessPageProps {
  description: string | React.ReactNode;
}

export const SuccessPage = ({ description }: SuccessPageProps) => {
  return (
    <div>
      <div className="flex items-center px-[80px] py-[24px]">
        <h2 className="text-blue-300 light !tracking-[5.6px]">SMARTFLYER</h2>
      </div>
      <div className="flex flex-col items-center justify-center h-[calc(100vh-100px)]">
        <SuccessIcon />
        <h2 className="text-blue-900 light mt-5">All set!</h2>
        {description}
      </div>
    </div>
  );
};